module.exports = __webpack_public_path__ + "img/logo_abz_weiss.28ebdea4.png";